import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgramacionN35Service {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getIdEmpresa(){
    return this.idEmpresa;
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusProgramacion(anio: number){
    let datos: any = {fechaCertificar: anio,	programacion: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusProgramacion(anio: number){
    let datos: any = {fechaCertificar: anio,	programacion: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  getReminders(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RegistrarRecordatorio + this.idEmpresa, datos);
  }

  getReminders_req(datos,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RegistrarRecordatorio + idEmpresa, datos);
  }

  getFechaLanzamiento35_req(data,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getfecha35+idEmpresa,data);
  }



  // nEW SERVIDE

  getStatu( productoid:any, Idioma: any){
    let datos: any = {productoId: productoid, programacion:1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.getStatus + this.idEmpresa, datos);
  }

  saveStatus(idproducto: any){
    let datos: any = {productoId: idproducto,	programacion: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoProgramacion(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  crearEncuesta(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.crearencuesta35 + this.idEmpresa, datos);
  }

  crearEncuesta50(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.encuestamas50 + this.idEmpresa, datos);
  }

  crearEncuestamenos50(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.encuestamenos50 + this.idEmpresa, datos);
  }
  saveUsuarios(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendUsers35 + this.idEmpresa, datos);
  }

  obtenerPilito(productoid:any){
    let productoId: any = productoid
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getPilot + this.idEmpresa, productoId);
  }

  creaUrlAutologin(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaUrlAutologSurvey + this.idEmpresa, datos);
  }

  saveRecordatorio(productoId:any,fechaRecordatorio:any){
    let datos: any = {productoId: productoId,	fechaRecordatorio: fechaRecordatorio};

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveRecordatorio + this.idEmpresa, datos);

  }

  getFechaLanzamiento35(data){
    this.obtienInfo();
    console.log("Data fecha lanzamiento");
    console.log(data);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getfecha35+this.idEmpresa,data);
  }

  registerDateBegin(data){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RegistarFecha +this.idEmpresa,data);

  }

  registerDateLanNormv2(data){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveDateLanzV2 +this.idEmpresa,data);

  }
  getDateLanNormv2(productoId:any){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getDateLanzV2 +this.idEmpresa+'/'+productoId);

  }

  getTemplatesNorma35(productoId:any){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getTemplatesNorma35 +this.idEmpresa+'/'+productoId);

  }

  saveTemplatesNorma35(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveTemplatesNorma35 +this.idEmpresa,datos);

  }

}
